// export const baseURL = "https://apiloyalty.novusloyalty.com/web/api/"; 
export const baseURL = "https://api-merchant.novus-loyalty.com/web/api/"; 

// export const baseURL = "http://localhost:4246/web/api/"; // 